export const SCAN_VIEWS = {
  B: 'B',
  C: 'C',
  D: 'D',
  A: 'A',
  threeD: '3D',
} as const;
